import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { TransitionTrigger } from './transition-trigger';

export class EnrolmentConfirmationRequestedTrigger extends TransitionTrigger {
	public orderingNumber = 40;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Sent to client', excludedEnrolmentStatuses);
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentConfirmationRequestedTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>): Promise<void> {
		await EnrolmentService.triggerEnrolmentConfirmationRequested(enrolments);
	}
}
